// Resize + compress an image File to a small JPEG data URL (base64) so it
// persists reliably through the API and renders fast.

export const isHeic = (file) =>
  /hei[cf]/i.test(file?.type || "") || /\.(heic|heif)$/i.test(file?.name || "");

// iPhone HEIC photos can't be decoded by Chrome/Android: convert them on our server first.
export async function ensureDecodable(file) {
  if (!isHeic(file)) return file;
  const fd = new FormData();
  fd.append("file", file);
  const r = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/media/heic-to-jpeg`, { method: "POST", body: fd });
  if (!r.ok) throw new Error("heic");
  const blob = await r.blob();
  return new File([blob], (file.name || "photo").replace(/\.(heic|heif)$/i, "") + ".jpg", { type: "image/jpeg" });
}

export async function compressImage(input, maxDim = 1600, quality = 0.82) {
  const file = await ensureDecodable(input);
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.onload = () => {
        let { width, height } = img;
        if (width > height && width > maxDim) { height = Math.round((height * maxDim) / width); width = maxDim; }
        else if (height > maxDim) { width = Math.round((width * maxDim) / height); height = maxDim; }
        const canvas = document.createElement("canvas");
        canvas.width = width; canvas.height = height;
        canvas.getContext("2d").drawImage(img, 0, 0, width, height);
        try { resolve(canvas.toDataURL("image/jpeg", quality)); } catch (e) { reject(e); }
      };
      img.onerror = reject;
      img.src = reader.result;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
